import React from "react";
import ImageryCoveragePanel from "./ImageryCoveragePanel";

export default function AoiCoverageHud({
  aoiName,
  coverage,
  loading,
}) {
  return (
    <div
      className="
        absolute top-80 right-3
        w-[300px]
        bg-bg-soft/60 backdrop-blur-md
        border border-slate-700/60 rounded-lg shadow-[0_4px_18px_rgba(0,0,0,0.35)]
        z-30
      "
    >
      <div className="px-3 py-2 border-b border-slate-700">
        <div className="text-[10px] font-mono uppercase tracking-wider text-fg-secondary">
          AOI
        </div>
        <div className="text-xs font-semibold text-gray-300 truncate">
          {aoiName}
        </div>
      </div>

      <ImageryCoveragePanel
        coverage={coverage}
        loading={loading}
      />
    </div>
  );
}